storefrontApp.service('topPicksElasticService', function () {
            this.buildTopPicksRequest = function () {
                return (
                    req = '{"track_total_hits": true, "query": { "bool": { "must": [ { "term": { "definitionName": { "value": "StockDesign" } } }, { "range": { "listPrice": { "gt": 0 } } } ] } },' + 
                    ' "size": 0, "aggs": { "top_picks": { "terms": { "field": "definitionName" },'+ 
                    ' "aggs": { "top_picks": { "top_hits": { "sort": [ { "yearCreated": { "order": "desc" } } ], "size": 100, "_source": { "includes": [ "brand", "catalog", "name", "listPrice", "salePrice", "itemId", "variants", "isBuyable", "definitionName" ] } } } } } } }'
                );
            }
            
    

    this.buildDefaultTopPicksRequest = function(){
                return (
                    req='{"track_total_hits": true, "query": { "bool": { "must": [ { "range": { "listPrice": { "gt": 0 } } },' + 
                    '{ "bool": { "should": [ { "match": { "definitionName": "StockDesign" } }, { "term": { "definitionName": "Font" } }, { "term": { "definitionName": "DesignPack" } } ] } } ] } },' +
                    '"size": 0, "aggs": { "definitions": { "terms": { "field": "definitionName" }, "aggs": { "topByDefinitions": { "top_hits": { "sort": [ { "_id": { "order": "desc" } } ], "size": 20,' +
                    '"_source": { "includes": [ "brand", "catalog", "name", "listPrice", "salePrice", "itemId", "variants", "isBuyable", "definitionName" ] } } } } } } }'
            );  

        
    }

    var shippableDefinitions = ["Supplies", "Equipment", "Embroiderable", "Quilting", "Thread", "CDPackage", "Education", "Collection"];
    this.buildShippableProductsRequest = function(){
        var shippingTerms = [];
            angular.forEach(shippableDefinitions, function (def) {
                shippingTerms.push({ term: { "definitionName": def } });
            });        
            var request='{"track_total_hits": true, "query": { "bool": { "must": [ { "range": { "listPrice": { "gt": 0 } } },'+ 
                '{ "bool": { "should":' + angular.toJson(shippingTerms) + '} } ], "filter": [{"term": {"inStock": true}}] } }, "size": 20 }';
            return request;
       
    }

    this.buildProductByIdsRequest = function(searchTerm){
        return(
            req='{"track_total_hits": true, "query":{"ids":{"values":' + searchTerm + '}}}'
        );
    }
});
